import type {SearchQueryResponseData} from '../queries/searchQuery';

/* @flow */
export const SEARCH_QUERY_COMPLETE = 'SEARCH_QUERY/COMPLETE';
export const SEARCH_QUERY_START = 'SEARCH_QUERY/START';

type SearchQueryStartActionType = 'SEARCH_QUERY/START';
type SearchQueryCompleteActionType = 'SEARCH_QUERY/COMPLETE';

type SearchQueryCompleteAction = {
    type: SearchQueryCompleteActionType,
    payload: SearchQueryResponseData
};

type SearchQueryStartAction = {
    type: SearchQueryStartActionType
};

export type Action = SearchQueryCompleteAction | SearchQueryStartAction;

const ACTION_CREATORS = {
    searchQueryComplete(
        data: SearchQueryResponseData
    ): SearchQueryCompleteAction {
        return {
            type: SEARCH_QUERY_COMPLETE,
            payload: data
        };
    },
    searchQueryStart(): SearchQueryStartAction {
        return {type: SEARCH_QUERY_START};
    }
};

export default {...ACTION_CREATORS};
